export const BASE_API_URL = process.env.REACT_APP_API;
